import { Component, Input, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { ControlDataFormCommandHandlerResolver } from '../../../accounting/service/command/control-data-export-file-command-handler-resolver.service';
import { PrintControlDataCommandHandler } from '../../../accounting/service/command/print-control-data-command-handler.service';
import { MultiselectObjectManagerComponentBase } from '../../../core/component/multiselect-object-manager/multiselect-object-manager.component';
import { ColumnVisibility } from '../../../core/model/column-definition';
import { DataService } from '../../../core/service/base/data.service';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { CommandFactoryService } from '../../../core/service/factory/command-factory.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { ControlDataExportCommand } from '../../command/control-data-export.command';
import { ControlDataExportFile } from '../../model/control-data/control-data-export-file';
import { ControlDataForm } from '../../model/control-data/control-data-form';
import { ControlDataExportCommandFactory } from '../../service/command/factory/control-data-export-command-factory.service';
import { ControlDataExportFileService } from '../../service/data/control-data-export-file.service';
import { ControlDataExportFormService } from '../../service/data/control-data-export-form.service';

@Component({
    selector: 'control-data-form-list',
    templateUrl: './control-data-form-list.component.html',
    styleUrls: ['./control-data-form-list.component.scss'],
    providers: [
        NavigationService,
        PrintControlDataCommandHandler,
        { provide: DataService, useExisting: ControlDataExportFormService },
        { provide: CommandHandlerResolver, useExisting: ControlDataFormCommandHandlerResolver },
        { provide: CommandFactoryService, useClass: ControlDataExportCommandFactory },
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ControlDataFormListComponent extends MultiselectObjectManagerComponentBase<ControlDataExportFile> implements OnDestroy {
  @Input() file: any;

  constructor(
    dataService: ControlDataExportFileService,
    dispatcher: CommandDispatcher,
    messageService: MessageService,
    navigationService: NavigationService,
    handlerResolver: ControlDataFormCommandHandlerResolver,
    private columnFactory: ColumnDefinitionFactory
  ) {
    super(dataService, dispatcher, handlerResolver, messageService, navigationService);
    this.columnDefinition = [
      this.columnFactory.create('CONTROL_DATA.FORM_NUMBER', 'formNumber', ColumnVisibility.mandatory),
      this.columnFactory.create(
        'COOPERATIVE_HOUSING.KU55.FK.630_BOSTRATTBETECKNING',
        'kU55Content.fK630_BostRattBeteckning',
        ColumnVisibility.mandatory
      ),
      this.columnFactory.createDate(
        'COOPERATIVE_HOUSING.KU55.FK.631_OVERLATELSEDATUM',
        'kU55Content.fK631_Overlatelsedatum',
        ColumnVisibility.default
      ),
      this.columnFactory.create('COOPERATIVE_HOUSING.KU55.FK.216_FORNAMN', 'kU55Content.fK216_Fornamn', ColumnVisibility.default),
      this.columnFactory.create('COOPERATIVE_HOUSING.KU55.FK.217_EFTERNAMN', 'kU55Content.fK217_Efternamn', ColumnVisibility.default),
      this.columnFactory.create('COOPERATIVE_HOUSING.KU55.FK.226_ORGNAMN', 'kU55Content.fK226_OrgNamn', ColumnVisibility.optional),
      this.columnFactory.createMoney(
        'COOPERATIVE_HOUSING.KU55.FK.643_FORVARVSPRIS',
        'kU55Content.fK643_Forvarvspris',
        ColumnVisibility.default
      ),
      this.columnFactory.createBoolean('COOPERATIVE_HOUSING.KU55.FK.205_BORTTAG', 'kU55Content.fK205_Borttag', ColumnVisibility.optional),
      this.columnFactory.createBoolean('COOPERATIVE_HOUSING.KU55.FK.210_RATTELSE', 'kU55Content.fK210_Rattelse', ColumnVisibility.optional),
      this.columnFactory.create('COOPERATIVE_HOUSING.KU55.MESSAGES', 'validationMessage', ColumnVisibility.default),
    ];

    this.addMultiselectMenuItem('COOPERATIVE_HOUSING.KU55.PRINT_TO_PDF', ControlDataExportCommand.printToPdf);
    this.addMultiselectMenuItem('COOPERATIVE_HOUSING.KU55.REGENERATE_CONTROL_DATA', ControlDataExportCommand.regenerateControlData);

    this.preferencesKey = 'rent.control-data-form.list';
  }

  onControlDataRowClicked(e: { context: ControlDataForm; event: any }): void {
    this.navigation.navigate(['cd-55', 'edit', e.context.id], null, e.event.ctrlKey);
  }
}
